import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { listerClickThrough } from '../../../../actions/lister-actions';
import { useIsProductInHighDemand } from '../../../../hooks/useIsProductInHighDemand';
import AddToBasketButton from '../../../ProductCard/AddToBasket/AddToBasketButton';
import BackInStockButton from '../../../ProductCard/BackInStockButton';
import BrandLogo from '../../../ProductCard/BrandLogo';
import Bullets from '../../../ProductCard/Bullets';
import CompareButton from '../../../ProductCard/CompareButton/CompareButton';
import DeliveryInformation from '../../../ProductCard/DeliveryInformation';
import EnergyInformation from '../../../ProductCard/EnergyInformation/EnergyInformation';
import NewEnergyInformation from '../../../ProductCard/EnergyInformation/NewEnergyInformation';
import FinanceProposition from '../../../ProductCard/FinanceProposition';
import Heading from '../../../ProductCard/Heading';
import HighDemandFlag from '../../../ProductCard/HighDemand/HighDemandFlag';
import HighDemandMessaging from '../../../ProductCard/HighDemand/HighDemandMessaging';
import MoreInfo from '../../../ProductCard/MoreInfo';
import PricePod from '../../../ProductCard/PricePod/PricePod@default';
import ProductImage from '../../../ProductCard/ProductImage/ProductImage';
import PromoFlag from '../../../ProductCard/PromoFlag';
import ReviewRating from '../../../ProductCard/ReviewRating/ReviewRating';
import StockStatus from '../../../ProductCard/StockStatus';
import { Context } from '../../store/store';
import LargeListViewSkeleton from './Skeletons/LargeListViewSkeleton';

export const LargeListViewContent = ({ product }) => {
	const [contextState] = useContext(Context);
	const { loaded } = contextState;

	const { ListerProductCardEnergyLabelEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const dispatch = useDispatch();

	const isSkuHighDemand = useIsProductInHighDemand(product);

	if (!product) {
		return null;
	}

	if (!loaded) {
		return <LargeListViewSkeleton />;
	}

	return (
		<>
			<div className="flex flex-col p-2 w-1/4 z-10">
				<ProductImage {...product} />

				<EnergyInformation
					classes="text-center mt-4"
					energyRatingDetails={product.EnergyRatingDetails}
				/>

				{isSkuHighDemand && <HighDemandFlag classes="mt-4" />}

				{!isSkuHighDemand && (
					<CompareButton
						classes="mt-auto"
						sku={product.Code}
						brand={product.Brand}
					/>
				)}
			</div>

			<div className="w-1/2 p-2 z-10" style={{ height: 'fit-content' }}>
				<a
					href={product.FullProductUrl}
					onClick={(event) => {
						event.preventDefault();
						window.location.assign(product.FullProductUrl);

						dispatch(listerClickThrough(product.Code));
					}}
					className="inline-block"
					itemProp="url"
					data-testid="product-card-link">
					<BrandLogo {...product} />

					<Heading content={product.FullTitle} />
				</a>

				<ReviewRating {...product} />

				<PromoFlag {...product} />

				<Bullets content={product.FeatureDescriptions} />
				{ListerProductCardEnergyLabelEnabled && (
					<NewEnergyInformation
						energyRatingDetails={product.EnergyRatingDetails}
					/>
				)}
			</div>

			<div className="flex flex-col justify-start p-2 w-1/4 lg:justify-between">
				<div>
					<PricePod
						product={product}
						viewModel={product.PricePodViewModel}
						inStock={product.State !== 'OutOfStock'}
						{...product}
					/>
				</div>

				{product.State !== 'OutOfStock' ? (
					<div className="z-10">
						{!isSkuHighDemand && (
							<DeliveryInformation
								deliveryInformation={product.DynamicDeliveryBulletsViewModel}
							/>
						)}
						{isSkuHighDemand && <HighDemandMessaging classes="my-4" />}

						{!isSkuHighDemand && (
							<AddToBasketButton classes="mt-2" {...product} />
						)}
						<MoreInfo {...product} classes="mt-2" />
					</div>
				) : (
					<div className="z-10">
						<StockStatus
							stockStatus={product.State}
							productCode={product.Code}
						/>
						<BackInStockButton {...product} classes="mt-2 z-10" />
						<MoreInfo {...product} classes="mt-2" />
					</div>
				)}
			</div>
		</>
	);
};

export default LargeListViewContent;
